import { styled } from '../styled';

export const StyledApplicationLogo = styled('img')`
  width: 150px;
`;
